import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const AdminChurches = () => {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/churches").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const toggle = async (c, internal) => {
    try {
      await api.put(`/admin/churches/${c.church_id}/internal`, { internal });
      toast.success(internal ? `${c.name} is now an internal testing account` : `${c.name} is back on its normal plan`);
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not update");
    }
  };
  return (
    <section className="card-soft p-7 mt-10" data-testid="admin-churches">
      <p className="font-display text-navy text-lg font-semibold">Churches</p>
      <p className="text-sm text-muted-ink mt-1">Internal testing accounts get full Pro access and are never charged. Turning it off restores their previous plan.</p>
      <table className="w-full text-left text-sm mt-5">
        <thead className="text-xs uppercase tracking-[0.12em] text-muted-ink"><tr><th className="py-2">Church</th><th>Plan</th><th>Status</th><th>Volunteers</th><th>Internal</th></tr></thead>
        <tbody className="divide-y divide-[var(--line)]">
          {list.map((c) => (
            <tr key={c.church_id} data-testid={`admin-church-${c.slug}`}>
              <td className="py-3 text-navy font-medium">{c.name} <span className="text-muted-ink font-normal">/{c.slug}</span></td>
              <td>{c.plan || "—"}</td>
              <td>{c.status}{c.status === "trialing" ? ` (${c.days_left}d)` : ""}</td>
              <td>{c.volunteers}</td>
              <td><Switch checked={c.internal} onCheckedChange={(v) => toggle(c, v)} data-testid={`admin-internal-${c.slug}`} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};
